import * as actions_authentication from 'actions/authentication-actions';
import * as actions_profiles from 'actions/profiles-actions';
import React, { useState } from 'react';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ROLES } from 'components/constants';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

export default function UserActivation(props) {

	const params = useParams();
    const dispatch = useDispatch();

    const company = useSelector((store) => store.company.company);
    
    const [buttonPending, setButtonPending] = useState(false);
    const [showActivation, setShowActivation] = useState(!props.user.activated);
    
    const linkUrl = `https://app.enspirex.com/#/${params.handle}/${params.appId}/register_user/${props.user.firstName}/${props.user.lastName}/${props.user.email}`;

    const sendInvite = () => {
        setButtonPending(true);
        dispatch(actions_authentication.sendUserInvitationEmail(params.handle, company, props.user, linkUrl, () => {
            setButtonPending(false);
            dispatch(actions_profiles.saveProfile({ 
                handle: params.handle, 
                profileId: params.profile_id, 
                profileForm: { modified: new Date() },
                profileType: 'EMPLOYEE',
                silent: true,
            }));
        }));
    };
    const sendPasswordReset = () => {
        setButtonPending(true);
        dispatch(actions_authentication.sendPasswordReset(props.user.email, () => setButtonPending(false)));
    };
    
    return (
    <>

        <div className="pl-3 mt-2">
            <div onClick={() => { setShowActivation(!showActivation); }} style={{ cursor: 'pointer', marginBottom: '7px', paddingBottom: '1px' }}>
                {showActivation
                    ? <span className="float-right px-1" style={{ fontSize: '16px' }}><i className="fas fa-angle-up"></i></span>
                    : <span className="float-right px-1" style={{ fontSize: '16px' }}><i className="fas fa-angle-down"></i></span>
                }
            </div>
            <div className="d-flex flex-wrap"><strong className="mr-2">Roles&nbsp;/&nbsp;Activation:</strong>
                {props.user.roles?.map((roleId) =>
                    <span key={roleId} className="label ml-2 mb-2 bg-secondary text-white">
                        {Object.values(ROLES).find((role) => role.id == roleId)?.name }
                    </span>
                )}
                {props.user.activated
                    ? <span className="label ml-2 mb-2" style={{ backgroundColor: 'limeGreen', color: 'white' }}>Activated</span>
                    : <span className="label label-warning ml-2 mb-2">Inactive</span>
                }
            </div>
        </div>

        <div>

            {showActivation &&
                <div className={`bg-${(props.bgColor) ? props.bgColor : 'grey' } px-3 py-2 mt-2`}>
                    {!props.user?.activated &&
                        <div className="mt-2">
                            <button className="btn btn-primary btn-sm mr-3" type="button" onClick={sendInvite}>Send Invitation Email
                                {buttonPending &&
                                    <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                                }
                            </button>
                            <span>Trouble receiving email?</span>
                            <CopyToClipboard
                                options={{ format: 'text/plain' }}
                                text={encodeURI(linkUrl)}
                                onCopy={() => window.toastr.success('The Registration link has been successfully copied to your clipboard.', 'Link Copied!')}
                            >
                                <button className="btn btn-secondary btn-xs btn-outline ml-2" type="button">Copy Link</button>
                            </CopyToClipboard>
                        </div>
                    }
        
                    {props.user.invitationSent &&
                        <p className="mt-2"><strong className="mr-2">Invitation Sent:</strong> {moment(props.user.invitationSent?.seconds, 'X').format('MMM Do YYYY,  h:mm a')}</p>
                    }
                    {props.user.activated &&
                        <>
                            <p className="m-0"><strong className="mr-2">Activated:</strong> {moment(props.user.activatedDate?.seconds, 'X').format('MMM Do YYYY,  h:mm a')}</p>
                            <button className="btn btn-info btn-sm mt-3" type="button" onClick={sendPasswordReset}>Send Password Reset Email
                                {buttonPending &&
                                    <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                                }
                            </button>
                        </>
                    }
                    {props.user.lastAuthenticated &&
                        <p className="m-0"><strong className="mr-2">Last Authenticated:</strong> {moment(props.user.lastAuthenticated.toDate()).format('MMM Do YYYY,  h:mm a')}</p>
                    }
                    <div style={{ clear: 'both' }} className="mb-3" />
                </div>
            }
        </div>
        </>
    );
};
